import {
  IS_GRID_LOADING,
  SET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  SET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
} from "./AssetAuditResetHistoryLogTypes";

const reducers = (state = [], action: any) => {
  switch (action.type) {
    case SET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA:
      return {
        ...state,
        assetAuditResetHistoryLogGridData: action.gridData,
      };
    case SET_ASSET_AUDIT_HISTORY_EXCEL_DATA:
      return {
        ...state,
        assetAuditResetHistoryLogExcelData: action.excelData,
      };
      case IS_GRID_LOADING:
            return {
                ...state,
                isGridLoading: action.flag,
            };
    default:
      return state;
  }
};

export default reducers;
